import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

export const fetchUserSessions = createAsyncThunk(
  "userSessions/fetchUserSessions",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/superAdmin/user-sessions", { params });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch sessions");
    }
  }
);

export const fetchSessionStats = createAsyncThunk(
  "userSessions/fetchSessionStats",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/superAdmin/user-sessions/stats", { params });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch stats");
    }
  }
);

const userSessionsSlice = createSlice({
  name: "userSessions",
  initialState: {
    sessions: [],
    total: 0,
    page: 1,
    limit: 50,
    stats: null,
    loading: false,
    statsLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserSessions.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchUserSessions.fulfilled, (state, action) => {
        state.loading = false;
        state.sessions = action.payload.sessions;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchUserSessions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSessionStats.pending, (state) => { state.statsLoading = true; })
      .addCase(fetchSessionStats.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.stats = action.payload;
      })
      .addCase(fetchSessionStats.rejected, (state) => { state.statsLoading = false; });
  },
});

export default userSessionsSlice.reducer;
